// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressIndicator {
  position: relative; }

.progressIndicator > .wrapper {
  width: 372px;
  z-index: 999;
  background: #ffffff; }

.progressBody {
  height: 300px;
  border-radius: 3px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.24); }

.uploadingItemsList {
  margin-top: 0px;
  height: 250px;
  position: relative;
  overflow-y: auto; }

.uploadingItem {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 15px;
  padding-top: 15px;
  margin-right: 20px;
  justify-content: space-between; }

.uploadingItem > .uploadingItemIcon {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 20px;
  min-width: 18px;
  min-height: 20px;
  padding-right: 12px;
  fill: #dbdfe2; }

.uploadingItem > .statusIcon {
  width: 14px;
  height: 18px; }

.progressTitle {
  font-size: 16px;
  font: bold;
  padding-left: 20px;
  padding-top: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e4e4; }

.uploadingItemName {
  color: #dce0e3;
  font-size: 13px;
  flex-grow: 1;
  width: 100%; }

.progressFooter {
  background-color: #f2f2f2;
  height: 70px;
  display: block;
  border-radius: 3px;
  box-shadow: -2px 0px 20px rgba(0, 0, 0, 0.24); }
  .progressFooter .progressIndicatorBar {
    position: relative;
    padding: 24px;
    font: bold;
    font-size: 11px; }
`, "",{"version":3,"sources":["webpack://./src/components/uploadProgressIndicator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAE;;AAEtB;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAE;;AAEvB;EACE,aAAa;EACb,kBAAkB;EAClB,4CAA4C,EAAE;;AAEhD;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B,EAAE;;AAElC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC,EAAE;;AAEpC;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,6CAA6C,EAAE;EAC/C;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,eAAe,EAAE","sourcesContent":[".progressIndicator {\n  position: relative; }\n\n.progressIndicator > .wrapper {\n  width: 372px;\n  z-index: 999;\n  background: #ffffff; }\n\n.progressBody {\n  height: 300px;\n  border-radius: 3px;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.24); }\n\n.uploadingItemsList {\n  margin-top: 0px;\n  height: 250px;\n  position: relative;\n  overflow-y: auto; }\n\n.uploadingItem {\n  display: flex;\n  flex-direction: row;\n  border-bottom: 1px solid #e4e4e4;\n  padding-bottom: 15px;\n  padding-top: 15px;\n  margin-right: 20px;\n  justify-content: space-between; }\n\n.uploadingItem > .uploadingItemIcon {\n  position: relative;\n  display: inline-block;\n  width: 18px;\n  height: 20px;\n  min-width: 18px;\n  min-height: 20px;\n  padding-right: 12px;\n  fill: #dbdfe2; }\n\n.uploadingItem > .statusIcon {\n  width: 14px;\n  height: 18px; }\n\n.progressTitle {\n  font-size: 16px;\n  font: bold;\n  padding-left: 20px;\n  padding-top: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e4e4e4; }\n\n.uploadingItemName {\n  color: #dce0e3;\n  font-size: 13px;\n  flex-grow: 1;\n  width: 100%; }\n\n.progressFooter {\n  background-color: #f2f2f2;\n  height: 70px;\n  display: block;\n  border-radius: 3px;\n  box-shadow: -2px 0px 20px rgba(0, 0, 0, 0.24); }\n  .progressFooter .progressIndicatorBar {\n    position: relative;\n    padding: 24px;\n    font: bold;\n    font-size: 11px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
